import { createSelector } from "reselect";
const selector = (state) => state.highlighted;

export default createSelector([selector], (data) => data);